import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import DataTable from 'react-data-table-component';
import { listProjectFiles } from '../../actions/projects'

import Nav from '../header/Nav.component';

import Loader from '../loader/Loader.component';
import AddFiles from '../modals/AddFiles.modal'
import { Link } from 'react-router-dom';

const columns = [
  {
    name: "Name",
    selector: "file_name",
    sortable: true,
    format: ({ file_name, file_color }) => (
      <span className='file'
        style={{
          "--color": `#${file_color}`,
          '--hover-color': file_color === 'ffffff' ? '' : `#${file_color}`,
          '--margin': file_color === 'ffffff' ? '10px' : `5px`
        }}
      >{file_name}</span>)
  },
  {
    name: "Notes",
    selector: "file_note",
    sortable: true,
    format: ({ file_note }) => <span className='tooltip' title={file_note}>{file_note}</span>,
    wrap: true
  },
  {
    name: "Tags",
    selector: "tags",
    format: ({ tags }) => (
      <span style={{ margin: '5px' }}>
        {tags.map((tag, index) => <span className='tag' key={index}>{tag}</span>)}
      </span>
    ),
    wrap: true
  }
  ,
  {
    name: "Created",
    selector: "date_created",
    sortable: true,
    format: row => (
      <span>
        {moment.unix(row.date_created).format("MM/DD/YYYY")},&nbsp;
        ({moment(moment.unix(row.date_created).format("MMDDYYYY"), 'MMDDYYYY').fromNow()})
      </span>
    )
  },
  {
    name: "Type",
    selector: "file_type",
    sortable: true
  },
  {
    name: "Size",
    selector: "file_size",
    sortable: true,
  }, {
    name: "Remove",
    selector: "_id",
    format: row => <span key={row._id} id={row._id}>x</span>,
    right: true
  }
];


class Files extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loadingFiles: true,
      showAddFilesModal: false
    }
    this.projectId = this.props.match.params.id
    this.projectFiles = []
  }
  async componentDidMount() {
    await this.props.listProjectFiles(this.projectId)
    this.setState({
      loadingFiles: false
    })
  }

  handleFilesModalClose = () => {
    this.setState({
      showAddFilesModal: false
    })
  }
  addFiles = () => {
    this.setState({ showAddFilesModal: !this.state.showAddFilesModal })
    this.projectFiles = this.props.projectFiles.files.map(file => file._id)
    console.log(this.projectFiles)
  }
  render() {
    return (
      <React.Fragment>
        <Nav active={2} />
        {!this.props.projectFiles ?
          <div className="loader flex-center"><Loader /></div>
          :
          <React.Fragment>
            <div className='content'>
              <div className="column">
                <div className="boxed_section">
                  <div className="boxed_header">
                    <h3>Project Files</h3>
                    <Link to='#' className='button'
                      onClick={this.addFiles}>Add</Link>
                    {this.state.showAddFilesModal ?
                      <AddFiles
                        projectId={this.projectId}
                        projectFiles={this.projectFiles}
                        showModal={this.state.showAddFilesModal}
                        handleClose={this.handleFilesModalClose}
                      />
                      :
                      <React.Fragment></React.Fragment>
                    }
                  </div>
                  <DataTable
                    columns={columns}
                    data={this.props.projectFiles.files}
                    defaultSortField="file_name"
                    pagination
                    highlightOnHover
                    pointerOnHover
                    progressPending={this.state.loadingFiles}
                    progressComponent={<Loader />}
                  />
                </div>
              </div>
            </div>
          </React.Fragment>
        }
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  projectFiles: state.projects.projectFiles
})

export default connect(mapStateToProps, { listProjectFiles })(Files)